import React, {Component} from 'react';
import _ from 'lodash';
import Loading from "../../loading";

class ActorsModal extends Component {
	render() {
		let {conclusion, active, closeModal, actors, fetching, selectedActors} = this.props;
		return <div className={`modal${active ? ' is-active' : ''}`}>
			<div className="modal-background" onClick={() => closeModal()}/>
			<div className="modal-content">
				<div className="message">
					<div className="message-header">
						<p>Seleccione los actores estratégicos que aplican</p>
						<button type="button" onClick={() => closeModal()} className="delete is-medium" aria-label="delete"></button>
					</div>
					<div className="message-body">
						{fetching ? <Loading/> :
							<div className="field is-grouped is-grouped-multiline conago-checkboxes">
								{_.map(actors, (actor, k) => {
									let selectedIndex = undefined;
									let shouldCheck = _.findKey(selectedActors, (o, sel) => {
										if(o.id === actor.id) {
											selectedIndex = sel;
											return true;
										}
									}) !== undefined ? true : false;
									return (
										<div className="control" key={k}>
											<label htmlFor={`actor-${actor.id}`} className="checkbox" disabled={conclusion}>
												<input
													id={`actor-${actor.id}`}
													ref={`g-actor-${actor.id}`}
													value={actor.id}
													type="checkbox"
													checked={shouldCheck}
													className="checkbox"
													onChange={() => this._saveActor(actor.id, actor, selectedIndex)}
													disabled={conclusion}
												/>
												{actor.name}
											</label>
										</div>
									)
								})}
							</div>
						}

						<br/><br/>
						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button className="button is-info" type="button" onClick={() => closeModal()}>
									Cerrar
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}

	_saveActor(id, actor, index) {
		if (this.refs[`g-actor-${id}`].checked) {
			this.props.add(`project.registry.data.project_goals[${this.props.selectedGoal}].actors`, actor);
		} else {
			this.props.remove(`project.registry.data.project_goals[${this.props.selectedGoal}].actors`, index);
		}
	}
}

export default ActorsModal;


// WEBPACK FOOTER //
// ./src/elements/project/widgets/project_actors_modal_widget.jsx